/** Session-weit: Avatar-URLs nach Ladefehler (429/404) nicht erneut anfragen. */
const failedAvatarUrls = new Set();

export function markAvatarUrlFailed(url) {
  const u = String(url || "").trim();
  if (u) failedAvatarUrls.add(u);
}

export function isAvatarUrlLoadFailed(url) {
  const u = String(url || "").trim();
  return Boolean(u && failedAvatarUrls.has(u));
}
